module.exports = __webpack_public_path__ + "img/a5c915b760ade0aff669734987e13d95.1ed68f3c.png";